<svg width="24" height="24" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.66602 10.998H18.3302" stroke="#000" stroke-width="1.6039" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.66602 5.49902H18.3302" stroke="#000" stroke-width="1.6039" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.66602 16.4971H18.3302" stroke="#000" stroke-width="1.6039" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
